export default __webpack_public_path__ + "static/technologie-c20b34e050068d49c1d9ac275e5ae1d2.webp";